export const hospitalImages: Record<string, string> = {
    "b1e35c34-eed1-40ff-a34f-7701f6c07fa3": "/maps/emory_university_hospital.png",
    "337be113-11d5-4933-b5e7-516994f4cfa2": "/maps/emory_university_hospital_midtown.png",
    "2a664de3-f450-4415-bb2f-9ae230b7f117": "/maps/emory_saint_josephs_hospital.png",
    "85629923-42f4-4ee9-889d-56a55dc041f6": "/maps/ejc/ejc_floor_1.png",
    "d759f721-003c-4401-8187-470f27e36508": "/maps/emory_rehabilitation_hospital.png",
    "264a4888-18b2-44b4-9ef6-a4c7fc8be910": "/maps/emory_decatur_hospital.png",
    "ffa8dbb7-d0c1-402d-af01-a313f1495bc4": "/maps/hillandale-campus-map.png",
    "f2dbe8a4-2844-4a6c-8a45-d5b1bf76832d": "/maps/emory_long_term_acute_care.jpeg",
    "9e5e7dc2-499f-4018-9a65-8d52eb505c83": "/maps/emory_wesley_woods_geriatric_hospital.jpeg",
    "7c9e6679-7425-40de-944b-e07fc1f90ae7": "/maps/emory_university_hospital_smyrna.png",
    "d3b07384-d992-4473-82a5-4d152d4372af": "/maps/emory_musculoskeletal_institute.png",
    "61899120-4a8b-497d-862d-94436577382d": "/maps/northlake/northlake_f1.png",
    "d4e35c34-eed1-40ff-a34f-7701f6c07fa3": "/maps/ep12/ep12_floor_1.png",
    "c3e35c34-eed1-40ff-a34f-7701f6c07fa3": "/maps/msk/msk_floor_L1.png",
};

export const hospitalFloorPlans: Record<string, Record<string, string>> = {
    "61899120-4a8b-497d-862d-94436577382d": {
        "1": "/maps/northlake/northlake_f1.png",
        "2": "/maps/northlake/northlake_f2.png",
    },
    "d4e35c34-eed1-40ff-a34f-7701f6c07fa3": {
        "1": "/maps/ep12/ep12_floor_1.png",
        "2": "/maps/ep12/ep12_floor_2.png",
        "3": "/maps/ep12/ep12_floor_3.png",
        "4": "/maps/ep12/ep12_floor_4.png",
        "5": "/maps/ep12/ep12_floor_5.png",
    },
    "85629923-42f4-4ee9-889d-56a55dc041f6": {
        "Site": "/maps/ejc/ejc_site.png",
        "LL": "/maps/ejc/ejc_floor_LL.png",
        "1": "/maps/ejc/ejc_floor_1.png",
        "2": "/maps/ejc/ejc_floor_2.png",
        "3": "/maps/ejc/ejc_floor_3.png",
        "4": "/maps/ejc/ejc_floor_4.png",
        "5": "/maps/ejc/ejc_floor_5.png",
        "6": "/maps/ejc/ejc_floor_6.png",
        "Powerhouse": "/maps/ejc/ejc_powerhouse.png",
    },
    "c3e35c34-eed1-40ff-a34f-7701f6c07fa3": {
        "B": "/maps/msk/msk_floor_B.png",
        "L1": "/maps/msk/msk_floor_L1.png",
        "L2": "/maps/msk/msk_floor_L2.png",
        "L3": "/maps/msk/msk_floor_L3.png",
        "L4": "/maps/msk/msk_floor_L4.png",
        "L5": "/maps/msk/msk_floor_L5.png",
        "L6": "/maps/msk/msk_floor_L6.png",
    },
    "2a664de3-f450-4415-bb2f-9ae230b7f117": {
        "G": "/maps/esjh/esjh_floor_G.png",
        "G (OSP/Winship)": "/maps/esjh/esjh_floor_G_OSP.png",
        "1": "/maps/esjh/esjh_floor_1.png",
        "1 (OSP/Winship)": "/maps/esjh/esjh_floor_1_OSP.png",
        "2": "/maps/esjh/esjh_floor_2.png",
        "2 (Harold Harrison)": "/maps/esjh/esjh_floor_2_OSP.png",
        "3": "/maps/esjh/esjh_floor_3.png",
        "4": "/maps/esjh/esjh_floor_4.png",
        "5": "/maps/esjh/esjh_floor_5.png",
        "6": "/maps/esjh/esjh_floor_6.png",
        "7": "/maps/esjh/esjh_floor_7.png",
        "PH": "/maps/esjh/esjh_floor_PH.png",
    },
    "b1e35c34-eed1-40ff-a34f-7701f6c07fa3": {
        "SB": "/maps/euh/01_Sub-Basement_Map.png",
        "Ground": "/maps/euh/02_Ground_Floor_Map.png",
        "1": "/maps/euh/03_1st_Floor_Map.png",
        "2": "/maps/euh/04_2nd_Floor_Map.png",
        "3": "/maps/euh/05_3rd_Floor_Map.png",
        "4": "/maps/euh/06_4th_Floor_Map.png",
        "5": "/maps/euh/07_5th_Floor_Map.png",
        "6": "/maps/euh/08_6th_Floor_Map.png",
        "7": "/maps/euh/09_7th_Floor_Map.png",
        "8": "/maps/euh/10_8th_Floor_Map.png",
        "9": "/maps/euh/11_9th_Floor_Map.png",
        "10": "/maps/euh/13_10th_Floor_Map.png",
        "11": "/maps/euh/14_11th_Floor_Map.png",
        "12": "/maps/euh/15_12th_Floor_Map.png",
    },
    "337be113-11d5-4933-b5e7-516994f4cfa2": {
        "Basement (D&T)": "/maps/euhm/page_003.png",
        "Basement (Visitor)": "/maps/euhm/page_004.png",
        "Ground (D&T)": "/maps/euhm/page_005.png",
        "Ground (Peachtree)": "/maps/euhm/page_006.png",
        "Ground (Orr/Glenn)": "/maps/euhm/page_007.png",
        "Ground (Visitor)": "/maps/euhm/page_008.png",
        "Lower Level (D&T)": "/maps/euhm/page_009.png",
        "Lower Level (Peachtree)": "/maps/euhm/page_010.png",
        "Lower Level (Orr/Glenn)": "/maps/euhm/page_011.png",
        "Lower Level (Visitor)": "/maps/euhm/page_012.png",
        "1st (Peachtree)": "/maps/euhm/page_013.png",
        "1st (Visitor)": "/maps/euhm/page_014.png",
        "2nd (D&T)": "/maps/euhm/page_015.png",
        "2nd (Peachtree)": "/maps/euhm/page_016.png",
        "2nd (Orr/Glenn)": "/maps/euhm/page_017.png",
        "2nd (Visitor)": "/maps/euhm/page_018.png",
        "3rd (D&T)": "/maps/euhm/page_019.png",
        "3rd (Peachtree)": "/maps/euhm/page_020.png",
        "3rd (Orr/Glenn)": "/maps/euhm/page_021.png",
        "3rd (Visitor)": "/maps/euhm/page_022.png",
        "4th (D&T)": "/maps/euhm/page_023.png",
        "4th (Peachtree)": "/maps/euhm/page_024.png",
        "4th (Orr/Glenn)": "/maps/euhm/page_025.png",
        "4th (Visitor)": "/maps/euhm/page_026.png",
        "5th (D&T)": "/maps/euhm/page_027.png",
        "5th (Peachtree)": "/maps/euhm/page_028.png",
        "5th (Orr/Glenn)": "/maps/euhm/page_029.png",
        "5th (Visitor)": "/maps/euhm/page_030.png",
        "6th (Peachtree)": "/maps/euhm/page_031.png",
        "6th (Orr/Glenn)": "/maps/euhm/page_032.png",
        "6th (Visitor)": "/maps/euhm/page_033.png",
        "7th (Peachtree)": "/maps/euhm/page_034.png",
        "7th (Orr/Glenn)": "/maps/euhm/page_035.png",
        "7th (Visitor)": "/maps/euhm/page_036.png",
        "8th (Peachtree)": "/maps/euhm/page_037.png",
        "8th (Orr/Glenn)": "/maps/euhm/page_038.png",
        "8th (Visitor)": "/maps/euhm/page_039.png",
        "9th (Orr/Glenn)": "/maps/euhm/page_040.png",
        "9th (Visitor)": "/maps/euhm/page_041.png",
        "10th (Orr/Glenn)": "/maps/euhm/page_042.png",
        "10th (Visitor)": "/maps/euhm/page_043.png",
        "11th (Orr/Glenn)": "/maps/euhm/page_044.png",
        "11th (Visitor)": "/maps/euhm/page_045.png",
        "Page 46": "/maps/euhm/page_046.png",
        "Page 47": "/maps/euhm/page_047.png",
        "Page 48": "/maps/euhm/page_048.png",
        "Page 49": "/maps/euhm/page_049.png",
        "Page 50": "/maps/euhm/page_050.png",
        "Page 51": "/maps/euhm/page_051.png",
        "Page 52": "/maps/euhm/page_052.png",
        "Page 53": "/maps/euhm/page_053.png",
        "Page 54": "/maps/euhm/page_054.png",
        "Page 55": "/maps/euhm/page_055.png",
    }
};

export const defaultMapImage = "/maps/emory_map_2.jpeg";

export function getHospitalImage(hospitalId?: string, floor?: string): string {
    if (!hospitalId) return defaultMapImage;

    if (floor && hospitalFloorPlans[hospitalId] && hospitalFloorPlans[hospitalId][floor]) {
        return hospitalFloorPlans[hospitalId][floor];
    }

    return hospitalImages[hospitalId] || defaultMapImage;
}

export function getAvailableFloors(hospitalId: string): string[] {
    if (!hospitalFloorPlans[hospitalId]) return [];
    return Object.keys(hospitalFloorPlans[hospitalId]).sort((a, b) => {
        const order = ["Site", "SB", "Basement", "Ground", "G", "Lower Level", "LL", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "PH", "Powerhouse"];

        // Find if any order matches the start of the string
        const getIndex = (val: string) => {
            for (let i = 0; i < order.length; i++) {
                if (val.startsWith(order[i])) return i;
            }
            return 999;
        };

        const idxA = getIndex(a);
        const idxB = getIndex(b);

        if (idxA !== idxB) return idxA - idxB;
        return a.localeCompare(b);
    });
}
